import DatePicker, { DateObject } from "react-multi-date-picker";
import { Calendar2, PersonalCard, Prerenderbg, Prerenderbg2, SmartPhone } from "../../../assets";
import { Button, Input, Layout } from "../../components";
import { PrePaymentController } from "../../controllers";
import persian_fa from "react-date-object/locales/persian_fa"
import persian from "react-date-object/calendars/persian"
import { Helmet } from "react-helmet-async";
import { numberWithCommas } from "../../../core/utils";
function CustomInput({ onFocus, value, onChange, emptyState, error }: any) {

    return (
        <Input error={error} emptyState={emptyState} onChange={onChange} customFocus={onFocus} myStyle="w-100" title="تاریخ تولد" value={value} icon={<Calendar2 />} />
    )
}
class PrePayment extends PrePaymentController {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        const { nationalCode, phoneNumber, price, birthdate, loading, error } = this.state;
        return (
            <Layout title="پیش پرداخت ها">
                <Helmet>
        <title>پیش پرداخت ها | بیمه زندگی هامرز </title>
      </Helmet>
                <div className="pre-payment scrollbar">
                <img src={Prerenderbg2} alt="" className="img-fluid hide-desktop bg-img-mobile" />

                    <div className="info-group">
                        <span className="pre-payment-title">
                            لطفا برای پیش پرداخت از اطلاعات بیمه گذار استفاده نمایید
                        </span>
                        <Input max="10" type="number" emptyState={() => this.setState({ nationalCode: "" })} error={error.filter((name: { path: string; }) => name.path === "nationalCode")?.[0]?.errors?.[0]} myStyle="w-100" title="کد ملی بیمه گذار" value={nationalCode}
                            onChange={(e: any) => this.setState({ nationalCode: e })} icon={<PersonalCard />} />
                        <Input max="11" type="number" emptyState={() => this.setState({ phoneNumber: "" })} error={error.filter((name: { path: string; }) => name.path === "phoneNumber")?.[0]?.errors?.[0]} myStyle="w-100" title="شماره موبایل بیمه گذار" value={phoneNumber} onChange={(e: any) => this.setState({ phoneNumber: e })} icon={<SmartPhone />} />

                        <div className="pre-payment-date-picker">

                            <DatePicker
                                ref={this.datePickerRef}
                                render={<CustomInput
                                emptyState={() => this.setState({ birthdate: "" })} error={error.filter((name: { path: string; }) => name.path === "birthdate")?.[0]?.errors?.[0]} />}
                                locale={persian_fa}
                                value={birthdate}
                                calendar={persian}
                                calendarPosition="bottom-right"
                                containerClassName="date-picker-container"
                                inputClass="date-picker-input"
                                onChange={this.handleChange}
                                maxDate={new DateObject({
                                    calendar: persian,
                                })}
                            // maxDate={new Date().setDate(1000)}
                            />

                        </div>
                        <div className="w-100 mb-2">
                        <Input hasComma hideEndAdornment type="number" max="13" error={error.filter((name: { path: string; }) => name.path === "price")?.[0]?.errors?.[0]} myStyle="w-100" title="مبلغ به ریال" value={price} onChange={(e: any) => this.setState({ price: e })} icon={<PersonalCard />} />
                        <div className="price-group">
                                <span className="item cursor-pointer ms-1" onClick={() => this.setState({ price: "500000" })}>{numberWithCommas(500000)} {" "} <span className="unit">
                                    ریال</span></span>
                                <span className="item cursor-pointer ms-1" onClick={() => this.setState({ price: "250000000" })}>{numberWithCommas(250000000)} {" "} <span className="unit">
                                    ریال</span></span>
                                <span className="item cursor-pointer " onClick={() => this.setState({ price: "500000000" })}>{numberWithCommas(500000000)} {" "} <span className="unit">
                                    ریال</span></span>
                            </div>
                        </div>


                        <div className="d-flex justify-content-end w-100">
                            <Button myStyle="bg-light-blue pre-payment-btn" title="پرداخت" onClick={() => this.createPreFactor()} loading={loading} />
                        </div>

                    </div>
                    <div className="terms-container hide-mobile">
                        <img src={Prerenderbg} alt="" className="img-fluid bg-img " />
                        <div className="terms-card">
                            <div className="custom-dash">
                                <span className="span">
                                    در نظر داشته باشید پیش پرداخت باید با نام بیمه گذار پرداخت گردد
                                </span>
                                <span>
                                    در وارد نمودن مبلغ و اطلاعات دقت نمایید در صورت پرداخت امکان بازگشت وجود ندارد
                                </span>
                                <span>
                                    پس از وارد کردن اطلاعات با یکی از روش های پرداخت نسبت به پرداخت اقدام نمایید.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

export default PrePayment;
